import { render, staticRenderFns } from "./ChatInbox.vue?vue&type=template&id=b387bda4"
import script from "./ChatInbox.vue?vue&type=script&lang=js"
export * from "./ChatInbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports